// extracted by mini-css-extract-plugin
export default {"main_layout":"NotFound_main_layout__ICl+8","main_content":"NotFound_main_content__fNRkh"};